import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ComingSoonComponent} from "./coming-soon/coming-soon.component";

const routes: Routes = [
  {
    path: '',
    component: ComingSoonComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewInDevelopmentRoutingModule { }
